module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "50%",
      "title": _vm.note && _vm.note.approved ? 'On-Air Details' : 'Approve for On-Air',
      "destroy-on-close": "",
      "visible": _vm.internalVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.internalVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.note) ? _c('div', [_c('div', {
    staticClass: "modal-meta"
  }, [_c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.note.sender))])])]), _vm._v(" "), (_vm.note.timestamp) ? _c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.note.timestamp)))])]) : _vm._e(), _vm._v(" "), (_vm.note.approved) ? _c('el-tag', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "mini",
      "type": "success",
      "effect": "dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-podcast"
  }), _vm._v(" On Air\n      ")]) : _vm._e(), _vm._v(" "), (_vm.note.flagged) ? _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "danger",
      "effect": "dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v(" Flagged\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('el-card', {
    staticClass: "transcript-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" Transcript Preview\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "transcript-text"
  }, [_vm._v(_vm._s(_vm.previewText))])]), _vm._v(" "), (_vm.note.approved) ? _c('div', [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-podcast"
  }), _vm._v(" On-Air Info ")]), _vm._v(" "), _c('div', {
    staticClass: "approved-info"
  }, [(_vm.note.approvedBy) ? _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Approved by")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "success",
      "effect": "plain"
    }
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" " + _vm._s(_vm.note.approvedBy) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.note.approvedAt) ? _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Approved on")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "info",
      "effect": "plain"
    }
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v(" " + _vm._s(_vm.formatDate(_vm.note.approvedAt)) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.note.approveReason) ? _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('span', {
    staticClass: "info-reason"
  }, [_vm._v(_vm._s(_vm.note.approveReason))])]) : _vm._e()]), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "type": "info",
      "closable": false,
      "show-icon": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n          To remove this voice note from on-air, go to the\n          "), _c('strong', [_vm._v("On-Air Panel")]), _vm._v(" on your dashboard.\n        ")])])], 1) : _c('div', [_c('el-divider'), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Approving As"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.approvedBy,
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-user el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Send On-Air To"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Select on-air user"
    },
    model: {
      value: (_vm.computedOnAirUser),
      callback: function($$v) {
        _vm.computedOnAirUser = $$v
      },
      expression: "computedOnAirUser"
    }
  }, _vm._l((_vm.companyUsers), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "label": user.display_name,
        "value": user.id
      }
    }, [_c('span', [_vm._v(_vm._s(user.display_name))]), _vm._v(" "), (user.id === _vm.me.id) ? _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#67c23a",
        "font-size": "12px"
      }
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(" You\n              ")]) : _vm._e()])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Date of Approval"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.approvalDate,
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-date el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reason / Comments (optional)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Add a reason or comment for this approval...",
      "rows": 3,
      "maxlength": "300",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("\n      " + _vm._s(_vm.note && _vm.note.approved ? 'Close' : 'Cancel') + "\n    ")]), _vm._v(" "), (_vm.note && !_vm.note.approved) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleApprove
    }
  }, [_vm._v("\n      Approve & Send On-Air\n    ")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c566b2e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/voiceIntelligence/modals/ApproveModal.vue
// module id = 3389
// module chunks = 3